import styled from 'styled-components';
import ImgBackground from '../../../../assets/svg/background-blue.svg';

const ContainerBackgroundImage = styled.div`
  background-image: url(${ImgBackground});
  width: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-size: cover;
  background-position: center;
`;

export { ContainerBackgroundImage };
